import type { Season } from '@features/seasonal-theme/types';

import { SEASONS } from '@features/seasonal-theme/utils/seasons';

const dayFormat = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });

/** e.g. "1–31 oct." or "30 nov." for a single day. */
export const formatSeasonRange = (season: Season, year: number): string => {
  const { start, end } = season.range(year);
  return start.getTime() === end.getTime() ? dayFormat.format(start) : dayFormat.formatRange(start, end);
};

/** Seasons in calendar order (`SEASONS` is ordered by priority). */
export const seasonsByCalendar = (year: number): Season[] =>
  [...SEASONS].sort((a, b) => a.range(year).start.getTime() - b.range(year).start.getTime());
